import React from "react";
import styled from "styled-components";

interface AccountBalanceItemProps {
  title?: string;
  amount: number;
  currency?: string;
  id?: string;
}
export const AccountBalanceItem: React.FC<AccountBalanceItemProps> = (
  props
) => {
  const [amount, faction] = props.amount.toFixed(2).split(".");
  return (
    <Container id={props.id}>
      <div className={"title"}>{props.title}</div>
      <div className={"amount"}>
        {props.currency}
        {amount}.<span>{faction}</span>
      </div>
    </Container>
  );
};

const Container = styled.div`
  text-align: center;
  .title {
    color: #afafaf;
    font-family: GT Walsheim Pro;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.02em;
  }
  .amount {
    font-family: GT Walsheim Pro;
    font-size: 30px;
    font-weight: 500;
    line-height: 34px;
    letter-spacing: 0.5px;

    span {
      font-family: Inter;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: 0.02em;
    }
  }
`;
